import React, { Component } from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { DateTime } from "luxon";
import Icon from '@material-ui/core/Icon';
import axios from "axios";
import _ from "lodash";
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withAuthorization } from '../Session';
import FlashMessage from 'react-flash-message'




const FF_BASE = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_FF_BASE_PROD : process.env.REACT_APP_FF_BASE_DEV





const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
});


const DISPLAY_X_DAYS = 90;

const formatDay = (ISO) => {
  const dt = DateTime.fromISO(ISO);
  return dt.toLocaleString({
    weekday: "short",
    day: "2-digit",
    month: "2-digit"
  });
};



class AvailabilityPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      authUser: JSON.parse(localStorage.getItem('authUser')),
      currentLocalDay: [],
      nextLocalDays: [],
      intervals:[],
      intervalsByDay: [],
      openDeletepopup: false,
      currentEditingIntervalstartISO: null,
      currentEditingIntervalendISO: null,
      instructorZone: '',
      instructorZoneName: '',
      instructorZoneOffset: '',
      instructorZoneNameShort: '',
      product: null,
      instructorName: null,
      errors: [],
      requestInprogress: false,
      flashTriggeredAt: null,
      flashMsg: null,
    };

    this.addIntervalSelector = this.addIntervalSelector.bind(this);
    this.handleEditInterval = this.handleEditInterval.bind(this);
    this.handleIntervalChange = this.handleIntervalChange.bind(this);
    this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
    // this.handleUpsert = this.handleUpsert.bind(this);
  }


  componentDidMount() {
    if (this.state.authUser !== null && this.state.authUser !== undefined) {
      
    
    if (this.state.nextLocalDays.length === 0) {
      const currentLocalDay = DateTime.local().startOf("day");
      let daysToAdd = [];
      for (let i = 0; i < DISPLAY_X_DAYS; i++) {
        daysToAdd[i] = currentLocalDay.plus({ days: i });
      }
      this.setState({ nextLocalDays: daysToAdd });
    }
    if(!this.state.timeslotsRequested) this.getIntervals();

    const userDT = DateTime.local()
  
    if(this.state.instructorZone === '') 
    { 
      this.setState({    
      instructorZone: userDT._zone.name,
      instructorZoneName: userDT.offsetNameLong,
      instructorZoneOffset: userDT.offset,
      instructorZoneNameShort: userDT.offsetNameShort
      });
    }

    this.setProduct();

   
    } else {
      this.props.history.push('/admin');
    }
   
  }

  setProduct = () => {
    if (this.state.authUser.can_do_ielts !== undefined && this.state.authUser.can_do_ielts === 'yes') {
      this.setState({product: 'IELTSSpeaking'});
    } else if (this.state.authUser.can_do_ielts !== undefined && this.state.authUser.can_do_ielts === 'no') { 
      this.setState({product: 'NONIELTS'});
    } else {
      this.setState({product: 'IELTSSpeaking'});
    }
  }

  setIntervalsBYdays = () => {
   let intervals = this.state.intervals;
   let intervalsBydays = [];
   
  let intervalsInLocalTime = _.each(intervals, interval => { 
      let startISO = DateTime.fromISO(interval.timing.startISO).toISO({includeOffset: true});
      interval.timing.startISO = startISO;
      let endISO = DateTime.fromISO(interval.timing.endISO).toISO({includeOffset: true});
      interval.timing.endISO = endISO;
   });
   this.setState({intervals: intervalsInLocalTime});
   let nextLocalDays = this.state.nextLocalDays;
   nextLocalDays.map( (day, index) => {
      const isoDate = day.toLocal().toISODate({}).replace(/-/g, "-");
      let intervalOfDay = { 'date': isoDate, 'intervals': [  ] };
      let intervalsOfCurrentDay = _.filter(intervals, interval => { 
        return interval.timing.startISO.includes(isoDate);
      });
      intervalsOfCurrentDay = _.sortBy(intervalsOfCurrentDay, [function(interval) { return interval.timing.startStamp; }]);
      intervalOfDay.intervals = intervalsOfCurrentDay;
      intervalsBydays.push(intervalOfDay);
      return intervalsBydays;
    });

    this.setState({intervalsBydays});
  }

  availabilityIntervals = (data) => {
    this.setState({errors: [], requestInprogress: true});
    const URL = `${FF_BASE}/availability`;
  
    return axios({
      method: 'post',
      url: URL,
      data
    })
    .then(response => {
        this.setState({ requestInprogress: false });
        return response
      })
      .catch(error => {
        this.setState({ requestInprogress: false });
        throw error
      });
  }

  getIntervals = () => {
    this.setState({timeslotsRequested: true})
    this.availabilityIntervals({payload: { operation: 'getIntervals', product: this.state.product, 
      instructor: this.state.authUser.email.replace(/\./g,'<dot>')}})
      .then((payloadDown) => {
        if(payloadDown.data && payloadDown.data.msg === 'Intervals found') 
        {
           this.setState({intervals: payloadDown.data.data});
           this.setIntervalsBYdays();
        } 
        else {
          this.setState({intervals: []});
          this.setIntervalsBYdays();
         }
      })
      .catch(err => {
        // ADD PROPER ERROR HANDLING HERE
      })
  }

  getIntervalsOfDay = (date) => {
    if (this.state.intervalsBydays !== undefined) {
      let intervalsByDay = _.find(this.state.intervalsBydays, function(interval) { return interval.date === date; });
      return intervalsByDay !== undefined? intervalsByDay : { date: date, intervals: [] }; 
    } else {
      return { date: date, intervals: [] };
    }
  }



  formatToHHMM = (date, AM_PM) => {
    date = DateTime.fromISO(date,  {setZone: true});
    return date.toLocaleString({
      hour: "2-digit",
      minute: "2-digit",
      hour12: AM_PM
    });
  };

  getTimeZoneString = (timeZoneOffset) => {
    let timeZone = (timeZoneOffset / 60 );
    let operator = '';
    let timeZoneString = '';
    if (timeZone < 0) {
      operator = '-';
      timeZone = timeZone * -1;
      timeZoneString = operator + '0' + timeZone + ':00';
    } else {
      operator = '+';
      timeZoneString = operator + '0' + timeZone + ':00';
    }
    return timeZoneString;
  }
  addIntervalSelector = (date, index) => {

   let timeZone = this.getTimeZoneString(this.state.instructorZoneOffset);

   let intervalsOfDay = this.getIntervalsOfDay(date);
   if (intervalsOfDay.intervals !== undefined) {
   let intervalsOfDayIndex = _.findIndex(this.state.intervalsBydays, function(obj) { return obj.date.includes(date); });
   let intervals = intervalsOfDay.intervals;
   let newIntervalObject = { 'displayMode': 'create', timing : { startISO:  date+'T00:00:00.000'+timeZone, endISO: date+'T00:00:00.000'+timeZone }};
   intervals.splice(index, 0, newIntervalObject);
   intervalsOfDay.intervals = intervals;
   let intervalsBydays = this.state.intervalsBydays;
   intervalsBydays[intervalsOfDayIndex]  = intervalsOfDay;
    this.setState({ intervalsBydays: intervalsBydays });
   }
  }

  handleUpsert = (date, displayMode, index) => {
    if (this.state.requestInprogress === false) {
      let intervalsOfDay = this.getIntervalsOfDay(date);
        let interval = intervalsOfDay.intervals[index];
      if (displayMode === 'create') {

        
        this.availabilityIntervals({ payload: {
          instructor: this.state.authUser.email.replace(/\./g,'<dot>'), 
          product: this.state.product,
          instructorZone: this.state.instructorZone.trim(),
          instructorZoneName: this.state.instructorZoneName.trim(),
          instructorZoneNameShort: this.state.instructorZoneNameShort.trim(),
          instructorZoneOffset: this.state.instructorZoneOffset,
          startISOLocalZone: interval.timing.startISO.trim(),
          endISOLocalZone: interval.timing.endISO.trim(),
          operation: 'add'
        }})
        .then(({data}) => {
          if(data.msg === 'error') {
            if(Array.isArray(data.error)) { 
              data.error.forEach(error => {});
              this.setState({ errors: data.error });
            }
            else { }
          } else if(data.msg === 'Done') {
            this.setState({ flashTriggeredAt: Date.now(), flashMsg: 'save confirmed' })
            console.log('creation confirmed')
            this.getIntervals();
          }
        })
      } else if(displayMode === 'edit') {
        this.availabilityIntervals({ payload: {
          isoIntervalToModify: interval.timing.intervalISO.trim(),
          instructor: this.state.authUser.email.replace(/\./g,'<dot>'),
          product: this.state.product,
          instructorZone: this.state.instructorZone.trim(),
          instructorZoneName: this.state.instructorZoneName.trim(),
          instructorZoneNameShort: this.state.instructorZoneNameShort.trim(),
          instructorZoneOffset: this.state.instructorZoneOffset,
          startISOLocalZone: interval.timing.startISO.trim(),
          endISOLocalZone: interval.timing.endISO.trim(),
          operation: 'update'
        }})
        .then(({data}) => {
          if(data.msg === 'error') {
            // ADD PROPER ERROR HANDLING HERE
            if(Array.isArray(data.error)) { 
              data.error.forEach(error => {});
              this.setState({ errors: data.error });
            }
            else if(data.error && data.error.errorMsg) {}
            else {}
          } else if(data.msg === 'Done') {
            this.setState({ flashTriggeredAt: Date.now(), flashMsg: 'change confirmed' })
            console.log('edit confirmed')
            this.getIntervals();
          }
        })
      }
    }
  }

  handleEditInterval = (date, intervalIndex) => {
    let intervalsOfDay = this.getIntervalsOfDay(date);
   
    if (intervalsOfDay.intervals !== undefined) {
      let intervalsBydays = this.state.intervalsBydays;
      let intervalsOfDayIndex = _.findIndex(this.state.intervalsBydays, function(obj) { return obj.date.includes(date); });
      let intervals = intervalsOfDay.intervals;
      let interval  = intervals[intervalIndex];
      
      interval['displayMode'] = 'edit';
      intervals[intervalIndex] = interval;
      intervalsOfDay.intervals = intervals;
      intervalsBydays[intervalsOfDayIndex]  = intervalsOfDay;
      
      this.setState({...this.state, intervalsBydays: intervalsBydays, currentEditingIntervalstartISO: interval.timing.startISO,  currentEditingIntervalendISO: interval.timing.endISO });
    }
  }

  handleCancelUpsert = (date, displayMode, intervalIndex) => {
    let intervalsOfDay = this.getIntervalsOfDay(date);
    if (intervalsOfDay.intervals !== undefined) {
      let intervalsBydays = this.state.intervalsBydays;
      let intervalsOfDayIndex = _.findIndex(this.state.intervalsBydays, function(obj) { return obj.date.includes(date); });
      let intervals = intervalsOfDay.intervals;
      let interval  = intervals[intervalIndex];

      if (interval.displayMode === 'create') {
        intervals.splice(intervalIndex,1);        
        intervalsOfDay.intervals = intervals;
        intervalsBydays[intervalsOfDayIndex] = intervalsOfDay;
        this.setState({ intervalsBydays: intervalsBydays });

      } else if(interval.displayMode === 'edit') {
        delete interval['displayMode'];
        interval.timing.startISO = this.state.currentEditingIntervalstartISO;
        interval.timing.endISO = this.state.currentEditingIntervalendISO;
        this.setState({ currentEditingIntervalstartISO: null, currentEditingIntervalendISO: null });

        intervals[intervalIndex] = interval;
        intervalsOfDay.intervals = intervals;
        intervalsBydays[intervalsOfDayIndex]  = intervalsOfDay;
        this.setState({ intervalsBydays: intervalsBydays });
      }
    }
  }

  handleIntervalChange = (date, interval, intervalIndex, e) => {
    // date = DateTime.fromFormat(date, { setZone: false });
    let timeZone = this.getTimeZoneString(this.state.instructorZoneOffset);
    date = date.split('T')[0];
    let intervalsOfDay = this.getIntervalsOfDay(date);
    if (intervalsOfDay.intervals !== undefined) {
      let intervalsBydays = this.state.intervalsBydays;
      let intervalsOfDayIndex = _.findIndex(this.state.intervalsBydays, function(obj) { return obj.date.includes(date); });
      interval.timing[e.target.name] = date+'T'+e.target.value+':00.000'+timeZone;
      intervalsOfDay.intervals[intervalIndex] = interval;
      intervalsBydays[intervalsOfDayIndex] = intervalsOfDay;

      this.setState({ intervalsBydays: intervalsBydays });
     }
  }

  handleDeleteInterval = (isoIntervalToModify, date) => {
    if(this.state.requestInprogress === false) {
      this.setState({ openDeletepopup: true, isoIntervalToModify: isoIntervalToModify, dateToModify: date  });
    }
  }

  handleConfirmDelete = () => {
    let _this = this;
    if(_this.state.requestInprogress === false) {
      _this.availabilityIntervals({ payload: {
        instructor: this.state.authUser.email.replace(/\./g,'<dot>'),
        product: _this.state.product,
        isoIntervalToModify: _this.state.isoIntervalToModify.trim(),
        operation: 'delete'
      }})
      .then(payload => {
        const {data = {}} = payload;
        if(data.msg === 'error' || !payload) {
          if(Array.isArray(data.error)) { 
            data.error.forEach(error => {});
            _this.setState({ errors: data.error });
          }
          else {}
        } else if(data.msg === 'Done') {
          this.setState({ flashTriggeredAt: Date.now(), flashMsg: 'delete confirmed' })
          console.log('delete confirmed')
          let intervalsOfDayIndex = _.findIndex(_this.state.intervalsBydays, function(obj) { return obj.date.includes(_this.state.dateToModify); });
          let intervalsBydays = _this.state.intervalsBydays;
          let intervalsObject = intervalsBydays[intervalsOfDayIndex];
          _.remove(intervalsObject.intervals, function(intervalObject) {
            return intervalObject.timing.intervalISO === _this.state.isoIntervalToModify.trim();
          });
          intervalsBydays[intervalsOfDayIndex] = intervalsObject;
          _this.setState({ intervalsBydays: intervalsBydays, openDeletepopup: false });
        }
      })
    }
  }

  handleClosePopup = () => {
    this.setState({openDeletepopup: false});
  }

  render() {
    return (
      <div>
        <div className={ this.state.requestInprogress? "loading" : "" } ></div>
        <div className="row"  style={{ textAlign: 'center', 'lineHeight': '1.5' }}>
          <div className="col-md-12" style={{fontWeight: 'bold'}} >
            Indicate your availability
          </div>
          { this.state.flashTriggeredAt && ((this.state.flashTriggeredAt+2000) > Date.now()) && 
<FlashMessage duration={4000} persistOnHover={true}>
<Grid container spacing={8}><Grid item xs={12}><Grid container justify="center" spacing={8}>
            <Grid/>
            <Grid  align="center">
            <div style={{ backgroundColor: '#5fb868',borderRadius: 5,padding: 2,paddingLeft: 8,paddingRight: 8,margin: 15,}}>
            {this.state.flashMsg }
            </div>
            </Grid>
            <Grid/>
        </Grid></Grid></Grid>
          </FlashMessage> }


          {/* <div className="col-md-12">
            Please indicate when you are available for test heroism.
          </div> */}

         { this.state.errors.map( (errorMessage, index) => { 
          return <div style={{ color: 'red', fontWeight: 'bold' }} className="col-md-12">
                    { errorMessage }
                 </div>
          }) }
         
         </div>
         <div className="row" style={{ 'lineHeight': '2' }}>
            <div className="col-md-12" style={{fontSize: 13}}>
              All times shown in your timezone: <i> { this.state.instructorZoneName }</i> 
            </div>
            
         </div>
         
        <div className="row" style={{ 'marginTop': '5px' }}> 
         <Paper className={styles.root}>
            <Table className={styles.table}>
              <TableHead>
                <TableRow>
                  <TableCell  >  </TableCell>
                  <TableCell align="left">
                   { this.state.product === 'IELTSSpeaking' && ( 'Availability for IELTS Speaking' )  }
                   { this.state.product === 'NONIELTS' && ( 'Availability for Feedback or AA' )  }
                   
                  </TableCell>
                  
                </TableRow>
              </TableHead>
              <TableBody>
              
               
                { this.state.nextLocalDays.map( (day, index) => {
                  const noHyphenDate = day.toISODate().replace(/-/g, "");
                  const readableDate = formatDay(noHyphenDate);
                
                  // { return (readableDate.includes('Monday') || index == 0)? (
                  //   <TableRow >
                  //     <TableCell style={{ 'width': '25%' }} component="th" scope="row">
                  //       Week starting on { readableDate }
                  //     </TableCell>
                  //     <TableCell align="left"></TableCell>
                  // </TableRow>
                  // ) :  '' }
                  
                  
              return <TableRow key={index}>
                      <TableCell component="th" scope="row">
                        { readableDate }
                      </TableCell>
                      <TableCell align="left">
                    
                      <Icon onClick={ this.addIntervalSelector.bind(this, day.toISODate(), 0) } style={{cursor: 'pointer', margin: '0', top: '50%', 'MsTransform': 'translateY(30%)', transform: 'translateY(30%)' }} color="primary" >
                            add_circle
                      </Icon>
                      
                      { this.getIntervalsOfDay(day.toISODate()).intervals.map( (interval, index) => { 
                        return <span key={index + '_timeslot'} >
                          
                          {/* **************************************** */}
                          { interval.displayMode !== undefined && ((interval.displayMode === 'create') || (interval.displayMode === 'edit')) && (
                            <span>
                            <span className="chip" style={{ display: 'inline-block',
                            padding: '0 10px 5px 10px',
                            fontSize: '15px',
                            lineHeight: '35px',
                            borderRadius: '25px',
                            backgroundColor: '#f1f1f1',
                            position: 'relative',
                            border: '0.5px solid gray'
                          }} >  

                          <div style={{ 'fontSize': '13px', 'textAlign': 'center', 'display': 'flow-root', 'marginBottom': '-21px' }}> 
                              <span style={{ 'float': 'left', 'marginLeft': '5px', 'marginTop': '-3px' }} >
                              From
                              </span>                               
                               <span style={{ 'float': 'right', 'marginRight': '26%', 'marginTop': '-3px' }} >
                               Until
                               </span>
                            </div> 

                                <select name = "startISO" onChange={ (e) => this.handleIntervalChange(interval.timing.startISO, interval, index, e) } value={ this.formatToHHMM(interval.timing.startISO, false) } style={{
                                    width: '75px',
                                    height: '20px',
                                    marginLeft: '0px',
                                    fontSize: 12

                                }}>
                                  <option value="00:00">00:00</option>
                                  <option value="00:30">00:30</option>
                                  <option value="01:00">01:00</option>
                                  <option value="01:30">01:30</option>
                                  <option value="02:00">02:00</option>
                                  <option value="02:30">02:30</option>
                                  <option value="03:00">03:00</option>
                                  <option value="03:30">03:30</option>
                                  <option value="04:00">04:00</option>
                                  <option value="04:30">04:30</option>
                                  <option value="05:00">05:00</option>
                                  <option value="05:30">05:30</option>
                                  <option value="06:00">06:00</option>
                                  <option value="06:30">06:30</option>
                                  <option value="07:00">07:00</option>
                                  <option value="07:30">07:30</option>
                                  <option value="08:00">08:00</option>
                                  <option value="08:30">08:30</option>
                                  <option value="09:00">09:00</option>
                                  <option value="09:30">09:30</option>
                                  <option value="10:00">10:00</option>
                                  <option value="10:30">10:30</option>
                                  <option value="11:00">11:00</option>
                                  <option value="11:30">11:30</option>
                                  <option value="12:00">12:00</option>
                                  <option value="12:30">12:30</option>
                                  <option value="13:00">13:00</option>
                                  <option value="13:30">13:30</option>
                                  <option value="14:00">14:00</option>
                                  <option value="14:30">14:30</option>
                                  <option value="15:00">15:00</option>
                                  <option value="15:30">15:30</option>
                                  <option value="16:00">16:00</option>
                                  <option value="16:30">16:30</option>
                                  <option value="17:00">17:00</option>
                                  <option value="17:30">17:30</option>
                                  <option value="18:00">18:00</option>
                                  <option value="18:30">18:30</option>
                                  <option value="19:00">19:00</option>
                                  <option value="19:30">19:30</option>
                                  <option value="20:00">20:00</option>
                                  <option value="20:30">20:30</option>
                                  <option value="21:00">21:00</option>
                                  <option value="21:30">21:30</option>
                                  <option value="22:00">22:00</option>
                                  <option value="22:30">22:30</option>
                                  <option value="23:00">23:00</option>
                                  <option value="23:30">23:30</option>
                                  <option value="23:59">23:59</option>

                                </select>
                                
                                <select name = "endISO" onChange={ (e) => this.handleIntervalChange(interval.timing.startISO, interval, index, e) } value={ this.formatToHHMM(interval.timing.endISO, false) } style={{
                                    width: '75px',
                                    height: '20px',
                                    marginLeft: '5px',
                                    fontSize: 12
                                }}>
                                  <option value="00:00">00:00</option>
                                  <option value="00:30">00:30</option>
                                  <option value="01:00">01:00</option>
                                  <option value="01:30">01:30</option>
                                  <option value="02:00">02:00</option>
                                  <option value="02:30">02:30</option>
                                  <option value="03:00">03:00</option>
                                  <option value="03:30">03:30</option>
                                  <option value="04:00">04:00</option>
                                  <option value="04:30">04:30</option>
                                  <option value="05:00">05:00</option>
                                  <option value="05:30">05:30</option>
                                  <option value="06:00">06:00</option>
                                  <option value="06:30">06:30</option>
                                  <option value="07:00">07:00</option>
                                  <option value="07:30">07:30</option>
                                  <option value="08:00">08:00</option>
                                  <option value="08:30">08:30</option>
                                  <option value="09:00">09:00</option>
                                  <option value="09:30">09:30</option>
                                  <option value="10:00">10:00</option>
                                  <option value="10:30">10:30</option>
                                  <option value="11:00">11:00</option>
                                  <option value="11:30">11:30</option>
                                  <option value="12:00">12:00</option>
                                  <option value="12:30">12:30</option>
                                  <option value="13:00">13:00</option>
                                  <option value="13:30">13:30</option>
                                  <option value="14:00">14:00</option>
                                  <option value="14:30">14:30</option>
                                  <option value="15:00">15:00</option>
                                  <option value="15:30">15:30</option>
                                  <option value="16:00">16:00</option>
                                  <option value="16:30">16:30</option>
                                  <option value="17:00">17:00</option>
                                  <option value="17:30">17:30</option>
                                  <option value="18:00">18:00</option>
                                  <option value="18:30">18:30</option>
                                  <option value="19:00">19:00</option>
                                  <option value="19:30">19:30</option>
                                  <option value="20:00">20:00</option>
                                  <option value="20:30">20:30</option>
                                  <option value="21:00">21:00</option>
                                  <option value="21:30">21:30</option>
                                  <option value="22:00">22:00</option>
                                  <option value="22:30">22:30</option>
                                  <option value="23:00">23:00</option>
                                  <option value="23:30">23:30</option>
                                  <option value="23:59">23:59</option>

                                </select>

                              <Icon onClick={ this.handleUpsert.bind(this, day.toISODate(), interval.displayMode, index) } style={{ margin: '0', top: '50%', 'MsTransform': 'translateY(30%)', transform: 'translateY(30%)', cursor: 'pointer' }} color="primary" >
                                  check_circle_outline
                              </Icon>
                              <Icon  onClick={ this.handleCancelUpsert.bind(this, day.toISODate(), interval.displayMode, index) } style={{ margin: '0', top: '50%', 'MsTransform': 'translateY(30%)', transform: 'translateY(30%)', cursor: 'pointer' }} color="primary" >
                                  cancel_circle_outline
                              </Icon>                      
                              </span>
                              <Icon onClick={ this.addIntervalSelector.bind(this, day.toISODate(), index + 1) } style={{cursor: 'pointer', margin: '0', top: '50%', 'MsTransform': 'translateY(30%)', transform: 'translateY(30%)' }} color="primary" >
                              add_circle
                              </Icon>
                              </span>

                             
                        )}

                        { interval.displayMode === undefined && (
                          <span>
                            <span className="chip" style={{ display: 'inline-block',
                            padding: '0 10px 5px 10px',
                            fontSize: '15px',
                            lineHeight: '35px',
                            borderRadius: '25px',
                            backgroundColor: '#f1f1f1',
                            position: 'relative',
                            border: '0.5px solid gray'
                          }} >
                          <span >
                            <div style={{ 'fontSize': '13px', 'textAlign': 'center', 'display': 'flow-root', 'marginBottom': '-21px' }}> 
                              <span style={{ 'float': 'left',  'marginTop': '-3px' }} >
                              From
                              </span>                              
                               <span style={{ 'float': 'right', 'marginRight': '26%', 'marginTop': '-3px' }} >
                               Until
                               </span>
                            </div> 
                            <span style={{ 'display': 'inline-block' }} >
                                  { this.formatToHHMM(interval.timing.startISO, true) } - { this.formatToHHMM(interval.timing.endISO, true) }
                            </span>
                          </span> 


                          <Icon  onClick={ this.handleEditInterval.bind(this, day.toISODate(), index) } style={{ cursor: 'pointer', margin: '0', top: '50%', 'MsTransform': 'translateY(15%)', transform: 'translateY(15%)' }} color="primary" >
                            edit_circle
                          </Icon>
                          <Icon disabled={ this.state.requestInprogress } onClick={ this.handleDeleteInterval.bind(this, interval.timing.intervalISO, day.toISODate() ) } style={{ margin: '0', top: '50%', 'MsTransform': 'translateY(15%)', transform: 'translateY(15%)',  cursor: 'pointer' }} color="primary" >
                            remove_circle_outline
                          </Icon>
                          </span>

                          <Icon onClick={ this.addIntervalSelector.bind(this, day.toISODate(), index + 1) } style={{cursor: 'pointer', margin: '0', top: '50%', 'MsTransform': 'translateY(15%)', transform: 'translateY(15%)' }} color="primary" >
                            add_circle
                          </Icon>
                        </span>
                        )}
  
                      {/* ******************************************** */}
                        </span>
                      }) }
                      
  
                          
  
  
                      
  
                      </TableCell>
                    </TableRow>
                    
                  
                 }) }
              </TableBody>
            </Table>
          </Paper>
          </div>

          <Dialog
            open={this.state.openDeletepopup}
            onClose={this.handleClosePopup}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">Delete Timeframe</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
               Do you want to permanently erase this Timeframe? <br />
               Note, that bookings which might exist in this timeframe will be left unchanged.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClosePopup} color="primary">
                No
              </Button>
              <Button onClick={this.handleConfirmDelete} color="primary" autoFocus>
                Yes
              </Button>
            </DialogActions>
          </Dialog>
          
      </div>
    );
  }
}

const condition = authUser => !!authUser;

export default compose(
  withAuthorization(condition),
)(AvailabilityPage);

